import React, { useContext } from "react";
import "./IndividualDocumentCard.scss";
import { Student } from "../../../../interfaces/User";
import { fullName } from "../../../../utils/format";
import classNames from "classnames";
import { configStore } from "../../../../contexts/ConfigContext";
import { Image } from "@evidenceb/athena-common/modules/Assets";
import useAssetsDetails from "../../../../hooks/useAssetsDetails";
import { defineMessages, useIntl } from "react-intl";
interface Props {
    student: Student;
    classroomCode: string;
    className?: string;
}

const IndividualDocumentCard = ({
    student,
    classroomCode,
    className,
}: Props) => {
    const {
        config: {
            logos,
            client_name,
            auth: { qrcode },
        },
    } = useContext(configStore);
    const assetsDetails = useAssetsDetails();
    const intl = useIntl();
    return (
        <div className={classNames("individual-document-card", className)}>
            <div className="individual-document-card__header">
                <div className="individual-document-card__header__title">
                    <div>
                        <span>{intl.formatMessage(messages.connectTitle)}</span>
                        <span>{client_name}</span>
                    </div>
                    <span>{fullName(student)}</span>
                </div>
                <div className="individual-document-card__header__logos">
                    <div className="individual-document-card__header__logos__client">
                        <Image
                            assetsDetails={assetsDetails}
                            src={logos.pdfLogo ?? logos.header_client}
                            alt=""
                        />
                    </div>
                    <div className="individual-document-card__header__logos__mascot">
                        {logos.mascotIcon && (
                            <Image
                                assetsDetails={assetsDetails}
                                src={logos.mascotIcon}
                                alt=""
                            />
                        )}
                    </div>
                </div>
            </div>
            <div className="individual-document-card__infos">
                <div
                    className={classNames(
                        "individual-document-card__infos__code",
                        { "--no-qr-code": !qrcode }
                    )}
                >
                    <div>
                        <span>
                            {intl.formatMessage(messages.writeClassCode)}
                        </span>
                        <span>{classroomCode}</span>
                    </div>
                    <div>
                        <span>
                            {intl.formatMessage(messages.writeStudentCode)}
                        </span>
                        <span>{student.code}</span>
                    </div>
                </div>
                {qrcode && (
                    <div className="individual-document-card__qr-code">
                        <Image
                            width={120}
                            assetsDetails={assetsDetails}
                            src={qrcode}
                            alt=""
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default IndividualDocumentCard;

const messages = defineMessages({
    connectTitle: {
        id: "dashboard-codeDocument-connectTitle",
        defaultMessage: "I connect to",
    },
    writeClassCode: {
        id: "dashboard-codeDocument-writeClassCode",
        defaultMessage: "I write my classroom code:",
    },
    writeStudentCode: {
        id: "dashboard-codeDocument-writeStudentCode",
        defaultMessage: "I write my student code:",
    },
});
